var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V48C39.5 48.8284 38.8284 49.5 38 49.5H2C1.17157 49.5 0.5 48.8284 0.5 48V2Z",
    fill: "#F2F6F9",
    stroke: "#608CBA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 25,
    r: 12,
    fill: "#343330"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9091 26.2226V29.0863C44.9091 29.3033 44.8229 29.5114 44.6695 29.6648C44.516 29.8182 44.3079 29.9044 44.0909 29.9044H35.9091C35.6921 29.9044 35.484 29.8182 35.3306 29.6648C35.1771 29.5114 35.0909 29.3033 35.0909 29.0863V26.2226C35.0909 26.1141 35.134 26.0101 35.2108 25.9334C35.2875 25.8566 35.3915 25.8135 35.5 25.8135C35.6085 25.8135 35.7126 25.8566 35.7893 25.9334C35.866 26.0101 35.9091 26.1141 35.9091 26.2226V29.0863H44.0909V26.2226C44.0909 26.1141 44.134 26.0101 44.2108 25.9334C44.2875 25.8566 44.3915 25.8135 44.5 25.8135C44.6085 25.8135 44.7126 25.8566 44.7893 25.9334C44.866 26.0101 44.9091 26.1141 44.9091 26.2226ZM38.244 22.8302L39.5909 21.4828V26.2226C39.5909 26.3311 39.634 26.4352 39.7108 26.5119C39.7875 26.5886 39.8915 26.6317 40 26.6317C40.1085 26.6317 40.2126 26.5886 40.2893 26.5119C40.366 26.4352 40.4091 26.3311 40.4091 26.2226V21.4828L41.7561 22.8302C41.8328 22.907 41.9369 22.9501 42.0455 22.9501C42.154 22.9501 42.2582 22.907 42.3349 22.8302C42.4117 22.7535 42.4548 22.6494 42.4548 22.5408C42.4548 22.4322 42.4117 22.3281 42.3349 22.2514L40.2895 20.2059C40.2515 20.1679 40.2064 20.1377 40.1567 20.1171C40.107 20.0965 40.0538 20.0859 40 20.0859C39.9463 20.0859 39.893 20.0965 39.8434 20.1171C39.7937 20.1377 39.7486 20.1679 39.7106 20.2059L37.6651 22.2514C37.5884 22.3281 37.5453 22.4322 37.5453 22.5408C37.5453 22.6494 37.5884 22.7535 37.6651 22.8302C37.7419 22.907 37.846 22.9501 37.9546 22.9501C38.0631 22.9501 38.1672 22.907 38.244 22.8302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.7a784da03f909f0c1f02449f59a157cb.svg";
export { ForwardRef as ReactComponent };